import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Guide, HomePage } from './pages';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/guia" element={<Guide/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
